module.exports = __webpack_public_path__ + "static/media/BITSA.74282868.svg";